import { register } from '../../../JavaScript/Utils'

// import type { Splide } from './Carousel.types'

declare global {
  interface Window {
    Splide?: Splide
  }
}

// Temporary solution since the type 'Splide' from Carousel.types does not seem constructable
type Splide = any

export const Carousel = (el: HTMLElement) => {
  const init = () => {
    const Splide = window.Splide
    const sliderContainer = el.querySelector('.splide-wrapper')
    const syncName: any = el.dataset.syncName // improve any
    const syncTarget: any = el.dataset.syncTarget // improve any

    const carousel = new Splide(sliderContainer, {
      type: el.dataset.noLoop ? 'slide' : 'loop',
      autoHeight: true,
      updateOnMove: true,
      autoplay: el.dataset.autoplay || false,
      interval: 4000,
      perPage: 1,
      perMove: 1,
      gap: '1rem',
      pagination: el.dataset.pagination || false,
      padding: el.dataset.noLoop ? { right: el.dataset.mobilePadding || 0 } : el.dataset.mobilePadding || 0,
      classes: {
        pagination: 'splide__pagination pagination',
        page: 'splide__pagination__page page-bubble cursor-pointer'
      },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          perPage: 2
        },
        1024: {
          perPage: +el.dataset.perPage || 3,
          destroy: el.dataset.mobileOnly || false,
          padding: el.dataset.noLoop ? { right: el.dataset.desktopPadding || 0 } : el.dataset.desktopPadding || 0
        }
      }
    })

    if (syncName) {
      window[syncName] = carousel
    }

    if (syncTarget && window[syncTarget]) {
      carousel.sync(window[syncTarget])
    }

    carousel.mount()
  }

  init()
}

register('Carousel', Carousel)
